import { Text } from '@televet/kibble-ui';
import { Flex, Th } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { TaskSortCriteria, TaskSortingKeys } from 'pages/Tasks/types';
import React from 'react';

type TaskColumnHeaderProps = {
  label: string;
  sortKey?: TaskSortingKeys;
  onSort?: (key: TaskSortingKeys) => void;
  currentSort?: TaskSortCriteria;
  testId?: string;
};

export const TaskColumnHeader = ({
  currentSort,
  onSort,
  sortKey,
  label,
  testId,
}: TaskColumnHeaderProps): JSX.Element => {
  if (sortKey && onSort) {
    return (
      <Th px={4} py={2} borderBottomWidth="1px" borderColor="border.default" data-testid={testId}>
        <Button
          iconName={
            currentSort?.key === sortKey ? (currentSort?.sortOrder === 'asc' ? 'caretUp' : 'caretDown') : 'caretDown'
          }
          variant="ghostNeutral"
          iconPosition="right"
          size="xs"
          onClick={(): void => onSort(sortKey)}
        >
          <Text size="xs" variant="subtle" fontWeight="normal" textTransform="uppercase">
            {label}
          </Text>
        </Button>
      </Th>
    );
  }

  return (
    <Th px={4} py={2} borderBottomWidth="1px" borderColor="border.default">
      <Flex alignItems="center">
        <Text size="xs" variant="subtle" fontWeight="normal">
          {label}
        </Text>
      </Flex>
    </Th>
  );
};
